export default {
    props: {
        excelFileName: {
            type: String,
            default: undefined,
            kComposite: 'excel.fileName'
        }, 
        excelForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'excel.forceProxy'
        }, 
        excelProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'excel.proxyURL'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/KendoSpreadsheet/Excel.js